// One row of the compact field's 11pt text, so `rows` sizes it like the textarea it stands in for.
export const ROW_HEIGHT_PX = 22;
